"use client";

import { c as _c } from "react/compiler-runtime";
import { CatalogCardDefinition, CatalogCardFrame, CatalogItemHeading, CatalogTileProps, PriceFooter, TypeCorner } from "../components/catalog-card-primitives";
import { StorefrontProductTile } from "../components/storefront-product-tile";
import React from "react";
import { FiActivity } from "react-icons/fi";
import { useShopDisplaySettings } from "@/contexts/shop-display-settings-provider";
const MedicationMotif: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><div className="absolute -bottom-24 -right-20 h-64 w-64 rounded-full border border-primary/10" /><div className="absolute right-7 top-8 h-7 w-16 -rotate-[24deg] rounded-full border border-primary/15" /><div className="absolute right-14 top-7 h-16 w-7 rotate-[24deg] rounded-full border border-primary/10" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const medicationCard: CatalogCardDefinition = {
  label: "Medication",
  Icon: FiActivity,
  visual: {
    background: "bg-[radial-gradient(circle_at_18%_0%,rgb(var(--primary)_/_0.10),transparent_56%)] bg-background",
    Motif: MedicationMotif
  },
  eyebrow: item => item.category ?? "Medication"
};
export const MedicationTile: React.FC<CatalogTileProps> = props => {
  const $ = _c(25);
  const {
    displayStyle
  } = useShopDisplaySettings();
  if (displayStyle === "STOREFRONT") {
    let t0;
    if ($[0] !== props) {
      t0 = <StorefrontProductTile {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  const {
    item,
    onSelect,
    compact: t0,
    className,
    opensDialog,
    placement,
    quantity,
    onQuantityChange
  } = props;
  const compact = t0 === undefined ? false : t0;
  let t1;
  if ($[2] !== compact) {
    t1 = <TypeCorner definition={medicationCard} compact={compact} />;
    $[2] = compact;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== item) {
    t2 = <CatalogItemHeading item={item} definition={medicationCard} />;
    $[4] = item;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = Boolean(onSelect);
  let t4;
  if ($[6] !== item || $[7] !== onQuantityChange || $[8] !== quantity || $[9] !== t3) {
    t4 = <PriceFooter item={item} interactive={t3} quantity={quantity} onQuantityChange={onQuantityChange} />;
    $[6] = item;
    $[7] = onQuantityChange;
    $[8] = quantity;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <div className="relative flex h-full flex-1 flex-col">{t2}{t4}</div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== className || $[15] !== compact || $[16] !== item || $[17] !== onQuantityChange || $[18] !== onSelect || $[19] !== opensDialog || $[20] !== placement || $[21] !== quantity || $[22] !== t1 || $[23] !== t5) {
    t6 = <CatalogCardFrame item={item} onSelect={onSelect} compact={compact} className={className} opensDialog={opensDialog} placement={placement} quantity={quantity} onQuantityChange={onQuantityChange} definition={medicationCard} corner={t1}>{t5}</CatalogCardFrame>;
    $[14] = className;
    $[15] = compact;
    $[16] = item;
    $[17] = onQuantityChange;
    $[18] = onSelect;
    $[19] = opensDialog;
    $[20] = placement;
    $[21] = quantity;
    $[22] = t1;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};